import { render, staticRenderFns } from "./ModalConfirmarCancelarDocumento.vue?vue&type=template&id=5104db56&scoped=true"
import script from "./ModalConfirmarCancelarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarCancelarDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarCancelarDocumento.vue?vue&type=style&index=0&id=5104db56&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104db56",
  null
  
)

export default component.exports